<template>
  <div v-if="$store.getters.user != null" class="container">
    <div
      v-if="
        scoreTemplate == null &&
          selectedStudent == null &&
          behaviorStudent == null
      "
    >
      <h4>Students</h4>
      <div class="row mb-4">
        <div class="col">
          <div class="row">
            <div class="col-auto pr-0 pt-1">
              <label>Filter Grades:</label>
            </div>
            <div class="col-auto">
              <select
                id="grade"
                name="gradePicker"
                class="form-control selectpicker"
                data-style="btn-sm btn-outline-primary"
                data-none-selected-text="All Grades"
                data-actions-box="true"
                v-model="filterByGrade"
                multiple
              >
                <option
                  v-for="grade in grades.slice().sort($orderByOrder)"
                  :key="grade.Grade_Id + 'grade'"
                  v-bind:value="grade.Grade_Id"
                  >{{ grade.Title }}</option
                >
              </select>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-auto pr-0 pt-1">
              <label>Search:</label>
            </div>
            <div class="col-auto">
              <input
                class="form-control form-control-sm"
                type="text"
                v-model="searchKeyword"
                placeholder="Name"
              />
            </div>
          </div>
        </div>
        <div class="col">
          <button
            class="btn btn-primary"
            v-if="canAddStudent"
            v-on:click="addStudent"
          >
            Add Student
          </button>
        </div>
      </div>
      <StudentRow
        v-for="student in filterStudents()
          .slice()
          .sort($orderByName)"
        :key="student.Student_Id"
        v-bind:Student="student"
        v-bind:BehaviorTrackers="behaviorTrackers"
        @student-unit-selected="studentUnitSelected"
        @student-selected="studentSelected"
        @student-tracker-selected="studentTrackerSelected"
      />
    </div>
    <AddStudentModal
      v-bind:Organizations="organizations"
      v-bind:Grades="grades"
      @student-added="loadData"
    />
    <div v-if="scoreTemplate != null">
      <div class="row">
        <div class="col-auto">
          <button class="btn btn-link" v-on:click="clearStudent">
            Back to Students
          </button>
        </div>
      </div>
      <StudentUnitScores
        v-bind:Student="scoreStudent"
        v-bind:ScoreTemplate="scoreTemplate"
        v-bind:Scores="unitScores"
        v-bind:Unit="scoreUnit"
        @archive-unit="archiveUnit"
      />
    </div>
    <div v-if="selectedStudent != null">
      <div class="row">
        <div class="col-auto">
          <button class="btn btn-link" v-on:click="clearStudent">
            Back to Students
          </button>
        </div>
      </div>
      <Student
        v-bind:Student="selectedStudent"
        v-bind:ScoreTemplates="scoreTemplates"
        v-bind:Users="users"
        v-bind:BehaviorSettings="behaviorSettings"
        v-bind:BehaviorTrackers="behaviorTrackers"
        v-bind:Organizations="organizations"
        v-bind:Grades="grades"
        @student-updated="studentUpdated"
        @student-edited="studentEdited"
        @student-managers-updated="studentManagersUpdated"
        @edited-tracker="editedTracker"
        @student-unit-unarchived="studentUnitUnarchived"
        @student-unit-archived="studentUnitArchived"
        @behavior-tracker-unarchived="behaviorTrackerUnarchived"
        @behavior-tracker-archived="behaviorTrackerArchived"
        @behavior-tracker-deleted="behaviorTrackerDeleted"
        @behavior-tracker-added="behaviorTrackerAdded"
      />
    </div>
    <div v-if="behaviorStudent != null || addBehaviorStudent != null">
      <div class="row">
        <div class="col-auto">
          <button class="btn btn-link" v-on:click="clearStudent">
            Back to Students
          </button>
        </div>
      </div>
      <StudentBehaviorScores
        v-bind:Student="behaviorStudent"
        v-bind:BehaviorTracker="behaviorTracker"
        v-bind:HideStudentName="false"
        v-bind:Users="users"
        v-bind:BehaviorSettings="behaviorSettings"
        @edited-tracker="editedTracker"
        @behavior-tracker-archived="behaviorTrackerArchived"
      />
    </div>
    <div>
      <BehaviorFormModal
        v-bind:BehaviorTracker="behaviorTracker"
        v-bind:Student="addBehaviorStudent"
        @added-scores="behaviorScoresAdded"
      />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import AddStudentModal from "@/modals/Student/AddStudentModal.vue";
import StudentRow from "@/components/Student/StudentRow.vue";
import Student from "@/components/Student/Student.vue";
import StudentUnitScores from "@/components/Score/StudentUnitScores.vue";
import StudentBehaviorScores from "@/components/Score/StudentBehaviorScores";
import BehaviorFormModal from "@/modals/Behavior/BehaviorFormModal.vue";

export default {
  name: "Students",
  components: {
    AddStudentModal,
    StudentRow,
    StudentUnitScores,
    Student,
    StudentBehaviorScores,
    BehaviorFormModal
  },
  watch: {
    "$store.getters.user": async function() {
      await this.loadData();
    }
  },
  data() {
    return {
      students: [],
      organizations: [],
      grades: [],
      organizationsCanManage: [],
      scoreTemplates: [],
      scoreTemplate: null,
      unitScores: [],
      scoreUnit: null,
      scoreStudent: null,
      selectedStudent: null,
      users: [],
      behaviorSettings: [],
      behaviorTrackers: [],
      behaviorTracker: null,
      behaviorScoreTemplate: null,
      behaviorStudent: null,
      filterByGrade: [],
      searchKeyword: "",
      addBehaviorStudent: null
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    async loadData() {
      this.$store.commit("updateLoading", true);
      var view = this;
      if (view.$store.getters.user != null) {
        view.scoreTemplates = await this.$getMyScoreTemplates();
        view.students = await view.$getMyStudents();
        view.organizations = await view.$getMySimpleOrganizations();
        view.grades = await view.$getAllGrades();
        view.users = await view.$queryUsers(
          view.organizations
            .filter(o => o.Organization_Type_Id == 3 || o.Organization_Type_Id == 4)
            .map(o => o.Organization_Id),
          null
        );
        view.behaviorSettings = await view.$getMyBehaviorSettings();
        view.behaviorTrackers = await view.$getMyBehaviorTrackers();
        if (view.$route.params.id) {
          view.selectedStudent = view.students.find(
            s => s.Student_Id == view.$route.params.id
          );
        }
        this.refreshGradeFilter();
        view.$store.commit("updateLoading", false);
      }
    },
    filterStudents() {
      var filteredStudents = this.students;
      if (this.filterByGrade.length > 0) {
        filteredStudents = filteredStudents.filter(s =>
          this.filterByGrade.includes(s.Grade.Grade_Id)
        );
      }
      if (this.searchKeyword != "") {
        filteredStudents = filteredStudents.filter(s =>
          s.Name.toLowerCase().includes(this.searchKeyword.toLowerCase())
        );
      }
      return filteredStudents;
    },
    canAddStudent() {
      return this.organizations.some(o =>
        this.$canManageOrganization(
          this.$store.getters.user.Permissions,
          o.Organization_Id
        )
      );
    },
    addStudent(organization) {
      this.organizationForStudents = organization;
      $("#addStudentModal").modal("show");
    },
    async studentUnitSelected(student, studentUnit) {
      this.$store.commit("updateLoading", true);
      this.scoreStudent = student;
      await this.$getStudentUnitScores(studentUnit.Student_Unit_Id).then(
        unitScores => {
          this.unitScores = unitScores;
          this.scoreUnit = studentUnit.Unit;
          this.scoreTemplate = this.scoreTemplates.find(
            t => t.Score_Template_Id == studentUnit.Unit.Score_Template_Id
          );
          this.$store.commit("updateLoading", false);
        }
      );
    },
    clearStudent() {
      this.scoreTemplate = null;
      this.selectedStudent = null;
      if (this.$route.params.id) {
        this.$router.replace({ params: { id: null } });
      }
      this.behaviorScoreTemplate = null;
      this.behaviorStudent = null;
      this.addBehaviorStudent = null;
      this.behaviorTracker = null;
      this.refreshGradeFilter();
    },
    studentSelected(student) {
      this.selectedStudent = student;
      if (this.$route.params.id != student.Student_Id) {
        this.$router.replace({ params: { id: student.Student_Id } });
      }
    },
    async studentTrackerSelected(student, tracker) {
      this.$store.commit("updateLoading", true);
      this.behaviorTracker = await this.$getBehaviorTracker(
        tracker.Behavior_Tracker_Id
      );
      this.$store.commit("updateLoading", false);
      if (
        this.$canManageStudent(
          this.$store.getters.user.Permissions,
          student.Student_Id
        )
      ) {
        this.behaviorStudent = student;
      } else {
        this.addBehaviorStudent = student;
        $("#behaviorTrackerModal").modal("show");
      }
    },
    studentUpdated(student) {
      var studentIndex = this.students.findIndex(
        s => s.Student_Id == student.Student_Id
      );
      this.$set(this.students, studentIndex, student);
      this.selectedStudent = student;
    },
    studentEdited(student) {
      var studentIndex = this.students.findIndex(
        s => s.Student_Id == student.Student_Id
      );
      this.students[studentIndex].Name = student.Name;
      this.students[studentIndex].Grade = student.Grade;
    },
    async studentManagersUpdated() {
      this.$store.commit("updateLoading", true);
      this.users = await this.$queryUsers(
        this.organizations
          .filter(o => o.Organization_Type_Id == 3)
          .map(o => o.Organization_Id),
        null
      );
      this.$store.commit("updateLoading", false);
    },
    editedTracker(editedTracker) {
      var trackerIndex = this.behaviorTrackers.findIndex(
        b => b.Behavior_Tracker_Id == editedTracker.Behavior_Tracker_Id
      );
      this.$set(this.behaviorTrackers, trackerIndex, editedTracker);
    },
    behaviorScoresAdded() {
      this.addBehaviorStudent = null;
    },
    studentUnitUnarchived(studentId, studentUnit) {
      var studentIndex = this.students.findIndex(
        s => s.Student_Id == studentId
      );
      this.students[studentIndex].Student_Units.push(studentUnit);
      this.selectedStudent = this.students[studentIndex];
    },
    studentUnitArchived(studentId, studentUnit) {
      var studentIndex = this.students.findIndex(
        s => s.Student_Id == studentId
      );
      this.students[studentIndex].Student_Units = this.students[
        studentIndex
      ].Student_Units.filter(
        s => s.Student_Unit_Id != studentUnit.Student_Unit_Id
      );
      this.selectedStudent = this.students[studentIndex];
    },
    async archiveUnit(unit) {
      this.$store.commit("updateLoading", true);
      await this.$archiveStudentUnitsPairs([
        { student: this.scoreStudent, unitIds: [unit.Unit_Id] }
      ]);
      this.scoreTemplate = null;
      this.studentUnitArchived(
        this.scoreStudent.Student_Id,
        this.scoreStudent.Student_Units.find(
          u => u.Unit.Unit_Id == unit.Unit_Id
        )
      );
      this.clearStudent();
      this.$store.commit("updateLoading", false);
    },
    behaviorTrackerUnarchived(behaviorTracker) {
      var trackerIndex = this.behaviorTrackers.findIndex(
        t => t.Behavior_Tracker_Id == behaviorTracker.Behavior_Tracker_Id
      );
      this.behaviorTrackers[trackerIndex].Is_Archived = false;
    },
    behaviorTrackerArchived(behaviorTracker) {
      var trackerIndex = this.behaviorTrackers.findIndex(
        t => t.Behavior_Tracker_Id == behaviorTracker.Behavior_Tracker_Id
      );
      this.behaviorTrackers[trackerIndex].Is_Archived = true;
      if (this.behaviorStudent != null) {
        this.clearStudent();
      }
    },
    behaviorTrackerDeleted(behaviorTracker) {
      this.behaviorTrackers = this.behaviorTrackers.filter(
        t => t.Behavior_Tracker_Id != behaviorTracker.Behavior_Tracker_Id
      );
    },
    behaviorTrackerAdded(newTracker) {
      this.behaviorTrackers.push(newTracker);
    },
    refreshGradeFilter() {
      var CONTROL_INTERVAL = setInterval(function() {
        if ($("#grade").length > 0) {
          $("#grade").selectpicker("val", this.filterByGrade);
          $(".selectpicker").selectpicker("refresh");
          clearInterval(CONTROL_INTERVAL);
        }
      }, 100);
    }
  }
};
</script>
